//Date Format
export const DATE_RANGE_FORMAT = "YYYY, MM, DD";
export const DAY_VIEW_DATA_FORMAT = "YYYY-MM-DD";
export const DATE_DD = "DD";
export const MOMENT_DAY = "day";
export const MOMENT_DAYS = "days";
export const MOMENT_HOUR = "hour";
export const MOMENT_MINUTE = "minute";
export const DAY_VIEW_HEADER_FORMAT = "dddd DD";
export const DATE_FORMAT = "DD";
export const MONTH_VIEW_FORMAT = "DD MMM YYYY";
export const FULL_MONTH_VIEW_FORMAT = "dd MMMM yyyy";
export const MONTH_VIEW_FORMAT_SIMPLE = "dd MMM yyyy";
export const YEAR_MONTH = "YYYY MMMM";

export const HOLIDAY_DATE_FORMAT = "YYYY/MM/DD";
export const DAY_FORMAT = "dddd";
export const DAY_WITH_DATE = "dddd DD/MM/YYYY";
export const YEAR_FORMAT = "YYYY";
export const DATEFORMAT = "DD/MM/YYYY";
export const DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
export const DATE_TIME_VISUAL_FORMAT = "YYYY-MM-DD HH:mm";

export const TOOL_TIP_FORMAT = "Do [of] MMMM YYYY";
export const DAY_VIEW_DATE_FORMAT = "MMMM DD, YYYY";
export const MONTH = "month";
export const WEEK = "week";
export const DAYS = "days";
export const DAY = "day";
export const YEAR = "year";
export const CALENDAR_FORMAT = "DD/MM/YYYY";
export const JS_DEFAULT_FORMAT = "MM/DD/YYYY";
export const DEFAULT_PICKER_FORMAT = "dd/MM/yyyy";
export const CHINA_JAPAN_FORMAT = "YYYY-M-D";
export const US_STANDARD_FORMAT = "M/D/YYYY";
export const MONTH_FORMAT = "MMMM";
export const MONTH_SHOT_FORMAT = "MMM";
export const MONTH_YEAR_SHORT_FORMAT = "MMM-YY";

//Auth
export const AUTH_USERNAME = "auth_username";
export const ACCESS_TOKEN = "accessToken";
export const AUTH = "Authorization";
export const BEARER = "Bearer";
export const AUTH_USER = "AuthUser";

export const CONFIGURATION = {
  auth: {
    GoogleClientId: process.env.REACT_APP_PUBLIC_GOOGLE_CLIENT_ID || "",
    navigateToLoginRequestUrl: false,
    redirectUri: "http://localhost:3000"
  },
  baseUrl: process.env.REACT_APP_BASE_API_URL || "",
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    iframeHashTimeout: 10000
  },
  stripe: {
    publishableKey: process.env.REACT_APP_PUBLISHABLE_KEY || ""
  }
};

//Regex
export const STRING_NUMBER_IDENTIFIER = /[a-z]+|[^a-z]+/gi;
export const LINK_IDENTIFIER =
  /((http | ftp | https): \/\/)?(([\w.-]*)\.([\w]*))/;

//user Enum
export enum StorageFields {
  User = "user",
}

//Notification Type
export enum NotificationType {
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info",
  WARNING = "warning",
}

export const PICKER_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

//Notification position
export enum NotificationPosition {
  TOP_RIGHT = "top-right",
  BOTTOM_RIGHT = "bottom-right",
  TOP_LEFT = "top-left",
  BOTTOM_LEFT = "bottom-left",
  TOP_MIDDLE = "top-middle",
}

//Alert Types
export const AlertVariant = {
  WARNING: "warning",
  INFO: "info",
  SUCCESS: "success",
  DANGER: "danger",
  SECONDARY: "secondary",
  PRIMARY: "primary",
  DARK: "dark",
  LIGHT: "light"
};

//Enum
export enum CalenderViewTypes {
  DAY_VIEW = "day",
  WEEK_VIEW = "week",
  MONTH_VIEW = "month",
  SCHEDULE_VIEW = "schedule",
  NEW_EVENT = "event",
}

export enum CalenderNames {
  DAY_VIEW = "Day View",
  WEEK_VIEW = "Week View",
  MONTH_VIEW = "Month View",
  SCHEDULE_VIEW = "Schedule View",
  NEW_EVENT = "New Event",
}

export enum ImageType {
  Fleet = "Fleet",
  Force = "Force",
  ClassModel = "ClassModel",
}

export const MAP_BOX_TOKEN = process.env.REACT_APP_MAP_BOX_API_TOKEN || "";

// validations
export enum ValidationTypes {
  NUMBER = "NUMBER",
  PERCENTAGE = "PERCENTAGE",
  YEAR_NUMBER = "YEAR_NUMBER",
  POSITIVE_VALUE = "POSITIVE_VALUE",
  POSITIVE_NUMBER = "POSITIVE_NUMBER",
}

export const Validations = {
  classTargetsValidations: {
    number: {
      type: ValidationTypes.NUMBER,
      message: "Please use only numbers"
    },
    percentage: {
      type: ValidationTypes.PERCENTAGE,
      message: "Input can not exceed 100"
    },
    yearNumber: {
      type: ValidationTypes.YEAR_NUMBER,
      message: "Input can not exceed 366"
    }
  },
  classRegistrationValidations: {
    lotNumber: {
      type: ValidationTypes.POSITIVE_NUMBER,
      message: "Input can not exceed 1000"
    },
    deliveryStagger: {
      type: ValidationTypes.POSITIVE_VALUE,
      message: "Input can not exceed 1000"
    },
    number: {
      type: ValidationTypes.NUMBER,
      message: "Please use only numbers"
    },
    percentage: {
      type: ValidationTypes.PERCENTAGE,
      message: "Input can not exceed 100"
    },
    yearNumber: {
      type: ValidationTypes.YEAR_NUMBER,
      message: "Input can not exceed 366"
    }
  },
  facilityManagementValidations: {
    number: {
      type: ValidationTypes.NUMBER,
      message: "Please use only numbers"
    }
  }
};

export const DEFAULT_CALENDAR_START_TIME = "06.00";
export const DEFAULT_IDLE_TIME = 1800; //30 min idle time

//Default timeout
export const DEFAULT_TIME_OUT = 100000;

//Status Codes
export const UNAUTHORIZED_STATUS = 401;
export const SUCCESS_STATUS = 200;
export const NO_CONTENT_STATUS = 204;
export const ACCESS_DENIED_STATUS = 403;
export const INTERNAL_SEVER_STATUS = 500;
export const BAD_REQUEST_STATUS = 400;

//Unauthorized
export const ACCESS_DENIED = "Access Denied";

//Messages
export const LOADING = "Loading...";
export const DATA_NOT_FOUND = "There is no data available at the moment!";
export const DEFAULT_ERROR_MESSAGE =
  "Oops, something went wrong. Please try again...";

export const languages = [
  { id: 1, language: "言語種類", value: "言語種類" },
  { id: 2, language: "English", value: "English" },
  { id: 3, language: "Japanese", value: "Japanese" },
  { id: 4, language: "French", value: "French" }
];

export const FavoriteList = [
  { id: 1, name: "Favorite", value: 1 },
  { id: 2, name: "Not Favorite", value: 0 }
];

export const COUNTRIES = [
  { name: "Afghanistan", value: "AF" },
  { name: "Åland Islands", value: "AX" },
  { name: "Albania", value: "AL" },
  { name: "Algeria", value: "DZ" },
  { name: "American Samoa", value: "AS" },
  { name: "Andorra", value: "AD" },
  { name: "Angola", value: "AO" },
  { name: "Anguilla", value: "AI" },
  { name: "Antarctica", value: "AQ" },
  { name: "Antigua and Barbuda", value: "AG" },
  { name: "Argentina", value: "AR" },
  { name: "Armenia", value: "AM" },
  { name: "Aruba", value: "AW" },
  { name: "Australia", value: "AU" },
  { name: "Austria", value: "AT" },
  { name: "Azerbaijan", value: "AZ" },
  { name: "Bahamas", value: "BS" },
  { name: "Bahrain", value: "BH" },
  { name: "Bangladesh", value: "BD" },
  { name: "Barbados", value: "BB" },
  { name: "Belarus", value: "BY" },
  { name: "Belgium", value: "BE" },
  { name: "Belize", value: "BZ" },
  { name: "Benin", value: "BJ" },
  { name: "Bermuda", value: "BM" },
  { name: "Bhutan", value: "BT" },
  { name: "Bolivia", value: "BO" },
  { name: "Bosnia and Herzegovina", value: "BA" },
  { name: "Botswana", value: "BW" },
  { name: "Bouvet Island", value: "BV" },
  { name: "Brazil", value: "BR" },
  { name: "British Indian Ocean Territory", value: "IO" },
  { name: "Brunei Darussalam", value: "BN" },
  { name: "Bulgaria", value: "BG" },
  { name: "Burkina Faso", value: "BF" },
  { name: "Burundi", value: "BI" },
  { name: "Cambodia", value: "KH" },
  { name: "Cameroon", value: "CM" },
  { name: "Canada", value: "CA" },
  { name: "Cape Verde", value: "CV" },
  { name: "Cayman Islands", value: "KY" },
  { name: "Central African Republic", value: "CF" },
  { name: "Chad", value: "TD" },
  { name: "Chile", value: "CL" },
  { name: "China", value: "CN" },
  { name: "Christmas Island", value: "CX" },
  { name: "Cocos (Keeling) Islands", value: "CC" },
  { name: "Colombia", value: "CO" },
  { name: "Comoros", value: "KM" },
  { name: "Congo", value: "CG" },
  { name: "Congo, The Democratic Republic of the", value: "CD" },
  { name: "Cook Islands", value: "CK" },
  { name: "Costa Rica", value: "CR" },
  { name: "Cote D'Ivoire", value: "CI" },
  { name: "Croatia", value: "HR" },
  { name: "Cuba", value: "CU" },
  { name: "Cyprus", value: "CY" },
  { name: "Czech Republic", value: "CZ" },
  { name: "Denmark", value: "DK" },
  { name: "Djibouti", value: "DJ" },
  { name: "Dominica", value: "DM" },
  { name: "Dominican Republic", value: "DO" },
  { name: "Ecuador", value: "EC" },
  { name: "Egypt", value: "EG" },
  { name: "El Salvador", value: "SV" },
  { name: "Equatorial Guinea", value: "GQ" },
  { name: "Eritrea", value: "ER" },
  { name: "Estonia", value: "EE" },
  { name: "Ethiopia", value: "ET" },
  { name: "Falkland Islands (Malvinas)", value: "FK" },
  { name: "Faroe Islands", value: "FO" },
  { name: "Fiji", value: "FJ" },
  { name: "Finland", value: "FI" },
  { name: "France", value: "FR" },
  { name: "French Guiana", value: "GF" },
  { name: "French Polynesia", value: "PF" },
  { name: "French Southern Territories", value: "TF" },
  { name: "Gabon", value: "GA" },
  { name: "Gambia", value: "GM" },
  { name: "Georgia", value: "GE" },
  { name: "Germany", value: "DE" },
  { name: "Ghana", value: "GH" },
  { name: "Gibraltar", value: "GI" },
  { name: "Greece", value: "GR" },
  { name: "Greenland", value: "GL" },
  { name: "Grenada", value: "GD" },
  { name: "Guadeloupe", value: "GP" },
  { name: "Guam", value: "GU" },
  { name: "Guatemala", value: "GT" },
  { name: "Guernsey", value: "GG" },
  { name: "Guinea", value: "GN" },
  { name: "Guinea-Bissau", value: "GW" },
  { name: "Guyana", value: "GY" },
  { name: "Haiti", value: "HT" },
  { name: "Heard Island and Mcdonald Islands", value: "HM" },
  { name: "Holy See (Vatican City State)", value: "VA" },
  { name: "Honduras", value: "HN" },
  { name: "Hong Kong", value: "HK" },
  { name: "Hungary", value: "HU" },
  { name: "Iceland", value: "IS" },
  { name: "India", value: "IN" },
  { name: "Indonesia", value: "ID" },
  { name: "Iran, Islamic Republic Of", value: "IR" },
  { name: "Iraq", value: "IQ" },
  { name: "Ireland", value: "IE" },
  { name: "Isle of Man", value: "IM" },
  { name: "Israel", value: "IL" },
  { name: "Italy", value: "IT" },
  { name: "Jamaica", value: "JM" },
  { name: "Japan", value: "JP" },
  { name: "Jersey", value: "JE" },
  { name: "Jordan", value: "JO" },
  { name: "Kazakhstan", value: "KZ" },
  { name: "Kenya", value: "KE" },
  { name: "Kiribati", value: "KI" },
  { name: "Korea, Democratic People'S Republic of", value: "KP" },
  { name: "Korea, Republic of", value: "KR" },
  { name: "Kuwait", value: "KW" },
  { name: "Kyrgyzstan", value: "KG" },
  { name: "Lao People'S Democratic Republic", value: "LA" },
  { name: "Latvia", value: "LV" },
  { name: "Lebanon", value: "LB" },
  { name: "Lesotho", value: "LS" },
  { name: "Liberia", value: "LR" },
  { name: "Libyan Arab Jamahiriya", value: "LY" },
  { name: "Liechtenstein", value: "LI" },
  { name: "Lithuania", value: "LT" },
  { name: "Luxembourg", value: "LU" },
  { name: "Macao", value: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", value: "MK" },
  { name: "Madagascar", value: "MG" },
  { name: "Malawi", value: "MW" },
  { name: "Malaysia", value: "MY" },
  { name: "Maldives", value: "MV" },
  { name: "Mali", value: "ML" },
  { name: "Malta", value: "MT" },
  { name: "Marshall Islands", value: "MH" },
  { name: "Martinique", value: "MQ" },
  { name: "Mauritania", value: "MR" },
  { name: "Mauritius", value: "MU" },
  { name: "Mayotte", value: "YT" },
  { name: "Mexico", value: "MX" },
  { name: "Micronesia, Federated States of", value: "FM" },
  { name: "Moldova, Republic of", value: "MD" },
  { name: "Monaco", value: "MC" },
  { name: "Mongolia", value: "MN" },
  { name: "Montserrat", value: "MS" },
  { name: "Morocco", value: "MA" },
  { name: "Mozambique", value: "MZ" },
  { name: "Myanmar", value: "MM" },
  { name: "Namibia", value: "NA" },
  { name: "Nauru", value: "NR" },
  { name: "Nepal", value: "NP" },
  { name: "Netherlands", value: "NL" },
  { name: "Netherlands Antilles", value: "AN" },
  { name: "New Caledonia", value: "NC" },
  { name: "New Zealand", value: "NZ" },
  { name: "Nicaragua", value: "NI" },
  { name: "Niger", value: "NE" },
  { name: "Nigeria", value: "NG" },
  { name: "Niue", value: "NU" },
  { name: "Norfolk Island", value: "NF" },
  { name: "Northern Mariana Islands", value: "MP" },
  { name: "Norway", value: "NO" },
  { name: "Oman", value: "OM" },
  { name: "Pakistan", value: "PK" },
  { name: "Palau", value: "PW" },
  { name: "Palestinian Territory, Occupied", value: "PS" },
  { name: "Panama", value: "PA" },
  { name: "Papua New Guinea", value: "PG" },
  { name: "Paraguay", value: "PY" },
  { name: "Peru", value: "PE" },
  { name: "Philippines", value: "PH" },
  { name: "Pitcairn", value: "PN" },
  { name: "Poland", value: "PL" },
  { name: "Portugal", value: "PT" },
  { name: "Puerto Rico", value: "PR" },
  { name: "Qatar", value: "QA" },
  { name: "Reunion", value: "RE" },
  { name: "Romania", value: "RO" },
  { name: "Russian Federation", value: "RU" },
  { name: "RWANDA", value: "RW" },
  { name: "Saint Helena", value: "SH" },
  { name: "Saint Kitts and Nevis", value: "KN" },
  { name: "Saint Lucia", value: "LC" },
  { name: "Saint Pierre and Miquelon", value: "PM" },
  { name: "Saint Vincent and the Grenadines", value: "VC" },
  { name: "Samoa", value: "WS" },
  { name: "San Marino", value: "SM" },
  { name: "Sao Tome and Principe", value: "ST" },
  { name: "Saudi Arabia", value: "SA" },
  { name: "Senegal", value: "SN" },
  { name: "Serbia and Montenegro", value: "CS" },
  { name: "Seychelles", value: "SC" },
  { name: "Sierra Leone", value: "SL" },
  { name: "Singapore", value: "SG" },
  { name: "Slovakia", value: "SK" },
  { name: "Slovenia", value: "SI" },
  { name: "Solomon Islands", value: "SB" },
  { name: "Somalia", value: "SO" },
  { name: "South Africa", value: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", value: "GS" },
  { name: "Spain", value: "ES" },
  { name: "Sri Lanka", value: "LK" },
  { name: "Sudan", value: "SD" },
  { name: "Suriname", value: "SR" },
  { name: "Svalbard and Jan Mayen", value: "SJ" },
  { name: "Swaziland", value: "SZ" },
  { name: "Sweden", value: "SE" },
  { name: "Switzerland", value: "CH" },
  { name: "Syrian Arab Republic", value: "SY" },
  { name: "Taiwan, Province of China", value: "TW" },
  { name: "Tajikistan", value: "TJ" },
  { name: "Tanzania, United Republic of", value: "TZ" },
  { name: "Thailand", value: "TH" },
  { name: "Timor-Leste", value: "TL" },
  { name: "Togo", value: "TG" },
  { name: "Tokelau", value: "TK" },
  { name: "Tonga", value: "TO" },
  { name: "Trinidad and Tobago", value: "TT" },
  { name: "Tunisia", value: "TN" },
  { name: "Turkey", value: "TR" },
  { name: "Turkmenistan", value: "TM" },
  { name: "Turks and Caicos Islands", value: "TC" },
  { name: "Tuvalu", value: "TV" },
  { name: "Uganda", value: "UG" },
  { name: "Ukraine", value: "UA" },
  { name: "United Arab Emirates", value: "AE" },
  { name: "United Kingdom", value: "GB" },
  { name: "United States", value: "US" },
  { name: "United States Minor Outlying Islands", value: "UM" },
  { name: "Uruguay", value: "UY" },
  { name: "Uzbekistan", value: "UZ" },
  { name: "Vanuatu", value: "VU" },
  { name: "Venezuela", value: "VE" },
  { name: "Viet Nam", value: "VN" },
  { name: "Virgin Islands, British", value: "VG" },
  { name: "Virgin Islands, U.S.", value: "VI" },
  { name: "Wallis and Futuna", value: "WF" },
  { name: "Western Sahara", value: "EH" },
  { name: "Yemen", value: "YE" },
  { name: "Zambia", value: "ZM" },
  { name: "Zimbabwe", value: "ZW" }
];

export const LESSON_POINTS = [
  { name: "100", value: 100 },
  { name: "200", value: 200 },
  { name: "300", value: 300 },
  { name: "400", value: 400 },
  { name: "500", value: 500 },
  { name: "600", value: 600 },
  { name: "700", value: 700 },
  { name: "800", value: 800 },
  { name: "900", value: 900 },
  { name: "1000", value: 1000 },
  { name: "1100", value: 1100 },
  { name: "1200", value: 1200 },
  { name: "1300", value: 1300 },
  { name: "1400", value: 1400 }
];

export const LANGUAGELEVELS: any = {
  Beginner: 1,
  Mid: 2,
  "Mid high": 3,
  Native: 4
};

export const getCancelHoursBefore = (): number => {
  const cancelHoursBefore = process.env.REACT_APP_CANCEL_HOURS_BEFORE;
  if (cancelHoursBefore !== undefined) {
    const parsedHours = parseInt(cancelHoursBefore, 10);
    return isNaN(parsedHours) ? 24 : parsedHours;
  }
  return 24;
};

const defaultParticipationCounts = [10, 20, 30];

export const getParticipationCounts = (): number[] => {
  const envValue = process.env.REACT_APP_MAX_PARTICIPATION_COUNT;
  if (!envValue) {
    return defaultParticipationCounts;
  }
  const participationCounts = envValue.split(",")
    .map(value => Number(value))
    .filter(value => !isNaN(value));
  return participationCounts.length > 0
    ? participationCounts
    : defaultParticipationCounts;
};

export const imageTypes = ["image/jpeg", "image/png"];

export const imageExtensionTypes = ["jpeg", "JPEG", "png", "PNG", "jpg", "JPG"];

export const maxImageSize: number = 2000000;

export const maxProfileImageSize: number = 10000000;
